import React, { Component } from "react";

import { observer, inject } from "mobx-react";

import { Select, MenuItem, Grid } from "@material-ui/core";
import MomentUtils from "@date-io/moment";
import moment from "moment";

import { MuiPickersUtilsProvider, DatePicker } from "material-ui-pickers";
import { BookingType, ProfileType } from "../../types/enum";

import EventIcon from "@material-ui/icons/Event";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import BookingCalendarFilter from "../../components/booking/bookingCalendarFilter";
import SelectField from "../fields/SelectField";
import IconButton from "@material-ui/core/IconButton";

const dateFormat = "DD-MM-YYYY";
const monthFormat = "MMM YYYY";

@inject("reportStore", "profileStore", "agentVenueStore", "venueStore")
@observer
class ReportDateFilter extends Component {
    constructor(props) {
        super(props);
        this.props.reportStore.resetFilterData();
    }

    componentDidMount() {
        this.getVenueList();
    }

    onChange = e => {
        this.props.reportStore.setFilterType(e.target.value);
        if (this.props.postChangeEvent) {
            this.props.postChangeEvent();
        }
    };

    onChangeStartDate = value => {
        const { endDate } = this.props.reportStore;
        this.props.reportStore.setStartDate(value);
        if (moment(value).endOf("day") > moment(endDate).endOf("day")) {
            this.props.reportStore.setEndDate(value);
        }
        if (this.props.postChangeEvent) {
            this.props.postChangeEvent();
        }
    };

    onChangeEndDate = value => {
        const { startDate } = this.props.reportStore;
        this.props.reportStore.setEndDate(value);
        if (moment(value).endOf("day") < moment(startDate).endOf("day")) {
            this.props.reportStore.setStartDate(value);
        }
        if (this.props.postChangeEvent) {
            this.props.postChangeEvent();
        }
    };

    onChangeMonth = value => {
        const startDate = moment(value).date(1);
        this.props.reportStore.setStartDate(startDate);

        const endDate = moment(value).date(moment(value).daysInMonth());
        this.props.reportStore.setEndDate(endDate);
        if (this.props.postChangeEvent) {
            this.props.postChangeEvent();
        }
    };

    onPrevMonth = () => {
        const { startDate } = this.props.reportStore;
        const prevMonth = moment(startDate).subtract(1, 'month');
        this.onChangeMonth(prevMonth);
    };

    onNextMonth = () => {
        const { startDate } = this.props.reportStore;
        const nextMonth = moment(startDate).add(1, 'month');
        this.onChangeMonth(nextMonth);
    }
    isAustralianCalendar = () => {
        const { currentProfile } = this.props.profileStore;
        return currentProfile?.currency === "AUD";
    };

    getAustralianFYQuarterDates = (fyYear, quarter) => {
        let startDate, endDate;
        switch (quarter) {
            case 1:
                startDate = moment().year(fyYear - 1).month(6).date(1).startOf("day");
                endDate = moment().year(fyYear - 1).month(8).endOf("month");
                break;
            case 2:
                startDate = moment().year(fyYear - 1).month(9).date(1).startOf("day");
                endDate = moment().year(fyYear - 1).month(11).endOf("month");
                break;
            case 3:
                startDate = moment().year(fyYear).month(0).date(1).startOf("day");
                endDate = moment().year(fyYear).month(2).endOf("month");
                break;
            case 4:
                startDate = moment().year(fyYear).month(3).date(1).startOf("day");
                endDate = moment().year(fyYear).month(5).endOf("month");
                break;
            default:
                startDate = moment();
                endDate = moment();
        }
        return { startDate, endDate };
    };

    getCurrentAustralianFY = () => {
        const now = moment();
        const month = now.month();
        if (month >= 6) {
            return now.year() + 1;
        }
        return now.year();
    };

    getCurrentAustralianFYQuarter = () => {
        const now = moment();
        const month = now.month();
        if (month >= 6 && month <= 8) return 1;
        if (month >= 9 && month <= 11) return 2;
        if (month >= 0 && month <= 2) return 3;
        return 4;
    };

    onChangeQuarter = value => {
        if (!value) return;
        
        if (this.isAustralianCalendar()) {
            const [fyPart, quarterPart] = value.split("-Q");
            const fyYear = parseInt(fyPart.replace("FY", ""));
            const quarter = parseInt(quarterPart);
            const { startDate, endDate } = this.getAustralianFYQuarterDates(fyYear, quarter);
            this.props.reportStore.setStartDate(startDate);
            this.props.reportStore.setEndDate(endDate);
        } else {
            const [year, quarter] = value.split("-Q");
            const startDate = moment().year(parseInt(year)).quarter(parseInt(quarter)).startOf("quarter");
            this.props.reportStore.setStartDate(startDate);
            const endDate = moment().year(parseInt(year)).quarter(parseInt(quarter)).endOf("quarter");
            this.props.reportStore.setEndDate(endDate);
        }
        
        if (this.props.postChangeEvent) {
            this.props.postChangeEvent();
        }
    };

    mapQuarterSuggestions = () => {
        const suggestions = [];
        
        if (this.isAustralianCalendar()) {
            const currentFY = this.getCurrentAustralianFY();
            for (let fy = currentFY; fy >= currentFY - 2; fy--) {
                for (let q = 4; q >= 1; q--) {
                    suggestions.push({
                        value: `FY${fy}-Q${q}`,
                        label: `Q${q} FY${fy}`
                    });
                }
            }
        } else {
            const currentYear = moment().year();
            for (let year = currentYear; year >= currentYear - 2; year--) {
                for (let q = 4; q >= 1; q--) {
                    suggestions.push({
                        value: `${year}-Q${q}`,
                        label: `Q${q} ${year}`
                    });
                }
            }
        }
        return suggestions;
    };

    getSelectedQuarterValue = () => {
        const { startDate } = this.props.reportStore;
        
        if (this.isAustralianCalendar()) {
            if (startDate) {
                const m = moment(startDate);
                const month = m.month();
                let fy, quarter;
                if (month >= 6 && month <= 8) {
                    fy = m.year() + 1;
                    quarter = 1;
                } else if (month >= 9 && month <= 11) {
                    fy = m.year() + 1;
                    quarter = 2;
                } else if (month >= 0 && month <= 2) {
                    fy = m.year();
                    quarter = 3;
                } else {
                    fy = m.year();
                    quarter = 4;
                }
                return `FY${fy}-Q${quarter}`;
            }
            return `FY${this.getCurrentAustralianFY()}-Q${this.getCurrentAustralianFYQuarter()}`;
        }
        
        if (startDate) {
            const m = moment(startDate);
            return `${m.year()}-Q${m.quarter()}`;
        }
        return `${moment().year()}-Q${moment().quarter()}`;
    };

    getVenueList = () => {
        const { currentProfile } = this.props.profileStore;

        if (currentProfile?.type === ProfileType.Agent.ordinal) {
            return this.props.agentVenueStore.getAgentVenueSimple();
        } else if (currentProfile?.type === ProfileType.Musician.ordinal) {
            this.props.reportStore.setVenueFilter(undefined);
        } else if (currentProfile?.type === ProfileType.Staff.ordinal) {
            return this.props.venueStore.getUserVenues();
        }
        return Promise.resolve();
    };

    mapVenueSuggestions = () => {
        const { currentProfile } = this.props.profileStore;
        var venueSuggestions = [];
        if (currentProfile?.type === ProfileType.Staff.ordinal) {
            const { venues } = this.props.venueStore;
            venueSuggestions = venues.map(venue => {
                return {
                    value: venue.id,
                    label: venue.profileName
                };
            });
        } else if (currentProfile?.type === ProfileType.Agent.ordinal) {
            const { agentVenues } = this.props.agentVenueStore;

            venueSuggestions = agentVenues.map(agentVenue => {
                return {
                    value: agentVenue.venue.id,
                    label: agentVenue.venue.profileName
                };
            });
        }

        if (venueSuggestions.length > 0) {
            venueSuggestions.unshift({
                value: 0,
                label: "All Venues"
            });
        }

        return venueSuggestions;
    };

    handleSelectVenue = value => {
        // const { currentProfile } = this.props.profileStore;
        // this.setState({
        //     ...this.state,
        //     selectedVenue: value,
        //     isLoading: true
        // });

        // if (!value || value === 0) {
        //     this.getActList().then(() => {
        //         this.setState({ isLoading: false });
        //     });
        // } else {
        //     if (currentProfile.type === ProfileType.Staff.ordinal) {
        //         this.props.venueActStore.getVenueActRoster(value).then(() => {
        //             this.setState({ isLoading: false });
        //         });
        //     } else {
        //         this.setState({ isLoading: false });
        //     }
        // }

        this.props.reportStore.setVenueFilter(value);
         if (this.props.postChangeEvent) {
            this.props.postChangeEvent();
        }
    };
     mapBookingType = () => {
        return [{
                value: undefined,
                label: "All"
            },{
                value: BookingType.Normal.ordinal,
                label: "Venue Booking"
            },{
                value: BookingType.Adhoc.ordinal,
                label: "Function Booking"
            }
        ];
    }
    onChangeBookingType = value => {
        this.props.reportStore.setBookingType(value);
        if (this.props.postChangeEvent) {
            this.props.postChangeEvent();
        }
    }

    render() {
        const { filterType, startDate, endDate, venueId, bookingType } = this.props.reportStore;
        const { currentProfile } = this.props.profileStore;
        const { isSocialPost, isBookingType } = this.props;

        const isAgent = currentProfile?.type === ProfileType.Agent.ordinal;
        return (
            <Grid container spacing={8} justify="flex-end" alignItems="center">
                {
                    isBookingType && !this.props.hideBookingTypeFilter ? 
                    <Grid item>
                        <BookingCalendarFilter
                            id="bookingType"
                            suggestions={this.mapBookingType()}
                            onChange={this.onChangeBookingType}
                            value={bookingType}
                            placeholder="Select Booking Type"
                            fullWidth={this.props.width === "xs" || this.props.width === "sm"}
                        />
                    </Grid> : null
                }
                {!this.props.hideVenueFilter && isAgent && !isSocialPost && (
                    <Grid item>
                        <BookingCalendarFilter
                            id="bookingVenue"
                            suggestions={this.mapVenueSuggestions()}
                            onChange={this.handleSelectVenue}
                            value={venueId}
                            placeholder="All Venues"
                            fullWidth={this.props.width === "xs" || this.props.width === "sm"}
                        />
                    </Grid>
                )}
                <Grid item>
                    <Select
                        label="Filter"
                        className="dark-select pull-right slim-dark-input slim-select-input"
                        value={filterType}
                        onChange={this.onChange}
                        inputProps={{
                            color: "primary"
                        }}
                        classes={{
                            root: "text-white",
                            icon: "text-white"
                        }}
                    >   
                        {/* {this.props.hideAllTime ? null : <MenuItem value="all">All-Time</MenuItem>}  */}
                        <MenuItem value="today">Today</MenuItem>
                        <MenuItem value="week">This Week</MenuItem>
                        <MenuItem value="lastweek">Last Week</MenuItem>
                        {/* <MenuItem value="month">This Month</MenuItem>
                        <MenuItem value="nextMonth">Next Month</MenuItem> */}
                        <MenuItem value="monthly">Month</MenuItem>
                        <MenuItem value="quarterly">Quarter</MenuItem>
                        <MenuItem value="custom">Custom</MenuItem>
                    </Select>
                </Grid>

                {filterType === "custom" && (
                    <Grid item>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                                emptyLabel="From"
                                margin="none"
                                className="dark-datepicker slim-month-input"
                                value={startDate}
                                onChange={this.onChangeStartDate}
                                keyboardIcon={<EventIcon />}
                                leftArrowIcon={<KeyboardArrowLeftIcon />}
                                rightArrowIcon={<KeyboardArrowRightIcon />}
                                format={dateFormat}
                                fullWidth
                                InputProps={{
                                    classes: {
                                        root: "text-white pull-right"
                                    }
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                )}
                {filterType === "custom" && (
                    <Grid item>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                                emptyLabel="to"
                                margin="none"
                                className="dark-datepicker slim-month-input"
                                value={endDate}
                                onChange={this.onChangeEndDate}
                                format={dateFormat}
                                keyboardIcon={<EventIcon />}
                                leftArrowIcon={<KeyboardArrowLeftIcon />}
                                rightArrowIcon={<KeyboardArrowRightIcon />}
                                fullWidth
                                InputProps={{
                                    classes: {
                                        root: "text-white pull-right"
                                    }
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                )}
                {filterType === "monthly" && (
                    <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton 
                            onClick={this.onPrevMonth}
                            size="small"
                            style={{ 
                                color: '#fff',
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                marginRight: 4,
                                width: 28,
                                height: 28
                            }}
                        >
                            <KeyboardArrowLeftIcon style={{ fontSize: 18 }} />
                        </IconButton>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                                views={["year", "month"]}
                                emptyLabel="to"
                                margin="none"
                                className="dark-datepicker slim-month-input"
                                value={startDate}
                                onChange={this.onChangeMonth}
                                format={monthFormat}
                                keyboardIcon={<EventIcon />}
                                leftArrowIcon={<KeyboardArrowLeftIcon />}
                                rightArrowIcon={<KeyboardArrowRightIcon />}
                                fullWidth
                                autoOk
                                InputProps={{
                                    classes: {
                                        root: "text-white pull-right"
                                    }
                                }}
                            />
                        </MuiPickersUtilsProvider>
                        <IconButton 
                            onClick={this.onNextMonth}
                            size="small"
                            style={{ 
                                color: '#fff',
                                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                marginLeft: 4,
                                width: 28,
                                height: 28
                            }}
                        >
                            <KeyboardArrowRightIcon style={{ fontSize: 18 }} />
                        </IconButton>
                    </Grid>
                )}
                {filterType === "quarterly" && (
                    <Grid item>
                        <BookingCalendarFilter
                            id="quarterFilter"
                            suggestions={this.mapQuarterSuggestions()}
                            onChange={this.onChangeQuarter}
                            value={this.getSelectedQuarterValue()}
                            placeholder="Select Quarter"
                            fullWidth={this.props.width === "xs" || this.props.width === "sm"}
                        />
                    </Grid>
                )}
            </Grid>
        );
    }
}

export default ReportDateFilter;
